import { Controller, useFormContext } from 'react-hook-form';

import * as S from '../styles';
import { FieldRendererProps } from '../types';

const CheckboxField = ({ field, disabled }: FieldRendererProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={[]}
      render={({ field: formField }) => (
        <S.CheckboxGroup>
          {field.options?.map((option) => {
            const isChecked = (formField.value || []).includes(option.value);

            const handleChange = () => {
              const currentValues = formField.value || [];
              if (isChecked) {
                formField.onChange(
                  currentValues.filter((v: string) => v !== option.value),
                );
              } else {
                formField.onChange([...currentValues, option.value]);
              }
            };

            return (
              <S.CheckboxLabel key={option.value} $disabled={disabled}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleChange}
                  disabled={disabled}
                />
                <span>{option.label}</span>
              </S.CheckboxLabel>
            );
          })}
        </S.CheckboxGroup>
      )}
    />
  );
};

export default CheckboxField;
